import { BsQuestionLg } from "react-icons/bs";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import Button from "../components/Button";
import { XButton } from "../../core/Helper";
import styled from "styled-components";
import { FaDownload, FaInfo, FaInfoCircle } from "react-icons/fa";
import { BiBorderAll } from "react-icons/bi";

export default function RcxDownload(props) {
  const [dlgState, setDlgState] = props.dlgState;

  const downloadUrl = "download/RCX_Dicom_with_JWT_Installer.exe";
  const displayName = "RCX_Dicom_with_JWT_Installer.exe";

  const handleClose = () => {
    setDlgState((pv) => ({ ...pv, show: false }));
    dlgState.callback();
  };

  const downloadAction = () => {
    const link = document.createElement("a");
    link.target = "_self";
    link.download = displayName;
    link.href = process.env.REACT_APP_API + downloadUrl;
    link.click();
  };

  return (
    <MyModal show={dlgState?.show} centered onHide={() => handleClose()}>
      <ModalHeaderBlack
        closeButton
        onHide={() => handleClose()}
        style={{
          display: "flex",
          justifyContent: "center",
          paddingInline: "10px",
        }}
      >
        <FaInfoCircle color="var(--icon-fore)" style={styles.iconButton} />
        ไม่พบเครื่องมือสำหรับค้นหา Zip ไฟล์
      </ModalHeaderBlack>
      <ModalBodyBlack>
        <DivContainer>
          <div style={styles.messageBox}>
            <FaInfoCircle
              color="var(--icon-fore)"
              size={150}
              style={styles.iconButton}
            />
            <SpanInfo>ระบบยังไม่ได้รับการติดตั้ง</SpanInfo>
            <SpanInfo>หรือ</SpanInfo>
            <SpanInfo>ตรวจพบรุ่นโปรแกรมที่ใหม่กว่า</SpanInfo>
          </div>

          <XButton onClick={() => downloadAction()}>
            <FaDownload
              size={20}
              color="var(--icon-fore)"
              style={styles.iconButton}
            />
            Download and Install
          </XButton>
        </DivContainer>
      </ModalBodyBlack>
    </MyModal>
  );
}

const DivContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-inline: 20px;
  padding-block: 15px;
  margin: 15px;
  color: var(--fore-primary);
`;

const styles = {
  iconButton: { marginInlineEnd: "5px" },
  messageBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBlock: "50px",
    flex: "1",
  },
};

const SpanInfo = styled.div`
  display: flex;
  justify-content: center;
`;
